<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["payment"] }}</p>
      </div>
      <div class="content_title">
        {{ this.$store.getters.TRANSLATIONS["please_pay"] }} ${{
          this.$store.getters.TOTAL_AMOUNT
        }}
        {{ this.$store.getters.TRANSLATIONS["with_credit_card"] }}
      </div>

      <div class="card" v-on:click="proceed()">
        <button class="button start">{{ this.cardNumber || "" }}</button>
        <button class="button end">
          {{ this.$store.getters.TRANSLATIONS["default"] }}
        </button>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="home()" class="button">
        {{ this.$store.getters.TRANSLATIONS["home"] }}
      </button>
      <button v-on:click="proceed()" class="button proceed">
        {{ this.$store.getters.TRANSLATIONS["proceed"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
      return;
    }
    if (this.$route.query.auto) {
      this.proceed();
      return;
    }
    if (this.$store.getters.USER.defaultCardId === null) {
      // const timeout = setTimeout(() => {
      //   this.loading = true;
      // }, 0);
      this.loading = true;
      this.$http
        .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
          headers: {
            "x-access-token": this.$storage.get("parkendaToken")
          }
        })
        .then((response) => {
          this.$store.dispatch("SAVE_USER", response.data);
          this.$store.dispatch(
            "SAVE_TOKEN",
            this.$storage.get("parkendaToken")
          );
          if (this.$store.getters.USER.defaultCardId === null) {
            this.$router.push(
              "/cardAddSquare?returnTo=payWithSquareUpCreditCard"
            );
          } else {
            const defaultCardId = this.$store.getters.USER.defaultCardId;
            // const timeout = setTimeout(() => {
            //   this.loading = true;
            // }, 0);
            this.loading = true;
            this.$http
              .get(
                `${process.env.SERVER_URL}/5D7F93F0081B40FF9AD2B5D57169EDCE/${defaultCardId}`,
                {
                  headers: {
                    "x-access-token": this.$storage.get("parkendaToken")
                  }
                }
              )
              .then((response) => {
                console.log("Get card by id response:");
                console.log(response);
                if (response.data) {
                  this.cardNumber = response.data.number;
                } else {
                  throw "";
                }
              })
              .catch((error) => {
                let text =
                  this.$store.getters.TRANSLATIONS[
                    "can_not_get_user_card_info"
                  ];
                this.$modal.show("dialog", {
                  text,
                  buttons: [
                    {
                      title: "OK",
                      handler: () => {
                        // this.$storage.remove("parkendaToken");
                        this.$router.push(
                          "/cardAddSquare?returnTo=requestInProgress"
                        );
                      }
                    }
                  ]
                });
              })
              .finally(() => {
                // clearTimeout(timeout);
                this.loading = false;
              });
          }
        })
        .catch((error) => {
          let text = this.$store.getters.TRANSLATIONS["can_not_get_user_info"];
          this.$modal.show("dialog", {
            text,
            buttons: [
              {
                title: "OK",
                handler: () => {
                  this.$storage.remove("parkendaToken");
                  this.$router.push("/hello");
                }
              }
            ]
          });
        })
        .finally(() => {
          // clearTimeout(timeout);
          this.loading = false;
        });
    } else {
      const defaultCardId = this.$store.getters.USER.defaultCardId;
      // const timeout = setTimeout(() => {
      //   this.loading = true;
      // }, 0);
      this.loading = true;
      this.$http
        .get(
          `${process.env.SERVER_URL}/5D7F93F0081B40FF9AD2B5D57169EDCE/${defaultCardId}`,
          {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          }
        )
        .then((response) => {
          console.log("Get card by id response:");
          console.log(response);
          if (response.data) {
            this.cardNumber = response.data.number;
          } else {
            throw "";
          }
        })
        .catch((error) => {
          let text =
            this.$store.getters.TRANSLATIONS["can_not_get_user_card_info"];
          this.$modal.show("dialog", {
            text,
            buttons: [
              {
                title: "OK",
                handler: () => {
                  // this.$storage.remove("parkendaToken");
                  this.$router.push(
                    "/cardAddSquare?returnTo=requestInProgress"
                  );
                }
              }
            ]
          });
        })
        .finally(() => {
          // clearTimeout(timeout);
          this.loading = false;
        });
    }
  },
  data() {
    return {
      loading: false,
      cardNumber: "",
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      back: () => {
        this.$router.push("/selectPayment?returnTo=parkingReceipt");
      },
      proceed: () => {
        this.displayDialog = "block";
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .get(`${process.env.SERVER_URL}/57A14732CFFD4C9E9B5EA5D3741F0954`, {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          })
          .then((response) => {
            if (response.data && response.data.length > 0) {
              /////
              const timeout = setTimeout(() => {
                this.loading = true;
              }, 0);
              this.$http
                .post(
                  `${process.env.SERVER_URL}/526F03F4CB7011EA87D00242AC130003`,
                  {
                    amount: parseFloat(
                      this.$store.getters.TOTAL_AMOUNT
                    ).toFixed(2),
                    tip: parseFloat(
                      this.$store.getters.LAST_PARKING_TIP
                    ).toFixed(2),
                    vehicleId: this.$store.getters.REQUESTED_VEHICLE.id
                  },
                  {
                    headers: {
                      "x-access-token": this.$storage.get("parkendaToken")
                    }
                  }
                )
                .then((response) => {
                  console.log("Charge parking receipt response:");
                  console.log(response);

                  this.$router.push("/appRating?returnTo=paymentProcessed");

                  // this.$modal.show("dialog", {
                  //   text: "Payment was successfully done",
                  //   buttons: [
                  //     {
                  //       title: "OK",
                  //       handler: () => {
                  //         this.$router.push("/paymentProcessed");
                  //       }
                  //     }
                  //   ]
                  // });
                })
                .catch((error) => {
                  let text =
                    this.$store.getters.TRANSLATIONS["something_went_wrong"];
                  if (
                    error.response &&
                    error.response.data &&
                    error.response.data.error
                  ) {
                    text = error.response.data.error;
                  }
                  this.$modal.show("dialog", {
                    text: this.$store.getters.TRANSLATIONS[
                      "payment_processing_failed"
                    ],
                    buttons: [
                      {
                        title: "Re-try",
                        handler: () => {
                          window.location.replace(
                            "/#/payWithSquareUpCreditCard?auto=1"
                          );
                          window.location.reload();
                        }
                      },
                      {
                        title: "Add Payment",
                        handler: () => {
                          this.$router.push(
                            "/cardAddSquare?returnTo=payWithSquareUpCreditCard"
                          );
                        }
                      }
                    ]
                  });
                })
                .finally(() => {
                  clearTimeout(timeout);
                  this.loading = false;
                });
            } else {
              this.$modal.show("dialog", {
                text: this.$store.getters.TRANSLATIONS["no_payment_on_file"],
                buttons: [
                  {
                    title: "Add Payment",
                    handler: () => {
                      this.$router.push(
                        "/cardAddSquare?returnTo=payWithSquareUpCreditCard"
                      );
                    }
                  }
                ]
              });
            }
          })
          .catch((error) => {
            console.log(error);
            clearTimeout(timeout);
            this.loading = false;
            this.$modal.show("dialog", {
              text: this.$store.getters.TRANSLATIONS[
                "payment_processing_failed"
              ],
              buttons: [
                {
                  title: "Re-try",
                  handler: () => {
                    window.location.replace(
                      "/#/payWithSquareUpCreditCard?auto=1"
                    );
                    window.location.reload();
                  }
                },
                {
                  title: "back",
                  handler: () => {
                    window.location.replace("/#/payWithSquareUpCreditCard");
                    window.location.reload();
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      home: () => {
        this.$router.push("/hello");
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.start {
  width: 50%;
  background-color: white;
  color: #fbae31;
  text-align: left;
  padding-left: 10px;
  margin-left: 17vw;
}
.end {
  position: absolute;
  width: 20%;
  margin-left: 55vw;
  background-color: #fbae31;
  color: white;
}
.proceed {
  background-color: rgba(114, 174, 255, 1);
  color: #ffffff;
}
.footer {
  height: 30vh;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/PayWithCreditCard.vue